module.exports = __webpack_public_path__ + "static/approved_rejected@2x.78d9143d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/membership/approved_rejected@2x.png
// module id = 714
// module chunks = 92562407457355